export default __webpack_public_path__ + "static/media/saudiArabiaFlagIcon.a778e607.svg";